import { z } from 'zod';

import type { TFunction } from 'i18next';

import { stripHtml } from '@/helpers';

export function createBookingProviderFormSchema(
  t: TFunction,
  isEditMode: boolean = false,
) {
  return z
    .object({
      name: z.string().refine((val) => stripHtml(val).trim().length > 0, {
        message: t('validation_required'),
      }),
      description: z.string(),
      provider_type: z.string().min(1, { message: t('validation_required') }),
      trainer_id: z.string().optional(),
      booking_service_ids: z
        .array(z.string())
        .min(1, { message: t('validation_required') }),
      order_position: z.preprocess(
        (val) => (val === '' || val === null ? 0 : Number(val)),
        z.number().positive({ message: t('validation_required') }),
      ),
      photo: z.union([z.instanceof(File), z.string()]).optional(),
      active: z.boolean(),
    })
    .refine(
      (data) => {
        if (data.provider_type === 'trainer') {
          return !!data.trainer_id && data.trainer_id.length > 0;
        }
        return true;
      },
      {
        message: t('validation_required'),
        path: ['trainer_id'],
      },
    )
    .refine(
      (data) => {
        if (isEditMode) {
          return true;
        }
        return !!data.photo;
      },
      {
        message: t('validation_required'),
        path: ['photo'],
      },
    );
}

export type BookingProviderFormInput = z.input<
  ReturnType<typeof createBookingProviderFormSchema>
>;

export type BookingProviderFormOutput = z.output<
  ReturnType<typeof createBookingProviderFormSchema>
>;
